import {
  Button,
  CloseButton,
  Dialog,
  ListContainer,
  ListContext,
  PAGE_DEFAULT,
  PAGE_SIZE_UNLIMITED,
  PageRoute,
  ScreenType,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  buildPath,
  buildTemplatePath,
  formatDate,
  handleClose,
  pn,
  useParams,
} from "@compass/core";
import { SubmitButton } from "components";

import {
  Permission,
  PermissionAction,
  StudentPostHighSchoolListDto,
  StudentPostHighSchoolListFilter,
  TextingOptIn as TextingOptInModel,
} from "generated/openApi";
import { useList, useRouter } from "hooks";
import { studentTextingOptinPageRoute } from "pages/students/student-texting-optin/StudentTextingOptinPage";
import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import ApiService from "services/apiService";

const routeName = "textingOptIn";

class Params {
  studentId: number = 0;
  screenType: ScreenType = "standard";
}

export const textingOptInPageRoute: PageRoute<Params> = {
  handle: "Texting Opt In",
  templatePath: buildTemplatePath(routeName, Params),
  getPath: (params) => buildPath(routeName, params),
};

export const TextingOptInPage = () => {
  const { params } = useParams(routeName, Params);
  const ROOT_PERMISSION: Permission = Permission.Texting;
  const navigate = useNavigate();
  const { matchTemplatePath } = useRouter();

  const [listFilter, setListFilter] = useState<StudentPostHighSchoolListFilter>({
    postHighSchoolFilter: { studentId: params.studentId },
    page: PAGE_DEFAULT,
    pageSize: PAGE_SIZE_UNLIMITED,
    sortObjects: [{ property: pn<TextingOptInModel>("id"), isDesc: false }],
  });
  const [listItems, setListItems] = useState<TextingOptInModel[]>([]);

  const { tableContainerRef, loadList } = useList({
    listFilter: listFilter,
    setListFilter: setListFilter,
    fetchList: (listFilter) => {
      ApiService.textingOptIn.getByStudentId(params.studentId).then((response) => {
        const arr = [response];
        setListItems(arr);
      });
    },
  });

  useEffect(() => {
    loadList(listFilter);
  }, []);

  const pageHeader = (
    <Stack direction="row" justifyContent="space-between">
      <Typography variant="inherit">{textingOptInPageRoute.handle}</Typography>

      <Stack direction="row" alignItems="center" spacing="sm">
        <CloseButton />

        {(isAuthorized(ROOT_PERMISSION, PermissionAction.Create) && listItems.filter(x => x.id == 0).length == 1) && (
          <Button
            variant="text"
            onClick={() =>
              navigate({
                pathname: studentTextingOptinPageRoute.getPath({
                  id: 0,
                  studentId: params.studentId,
                  crudMode: "edit",
                  screenType: "dialog",
                }),
              })
            }
            sx={{ minWidth: "auto", color: "info.main" }}
          >
            + New
          </Button>
        )}

      </Stack>
    </Stack>
  );

  const pageBody = (
    <>
      <ListContainer
        fullHeight
        headerNoPadding
        // header={
        //   <Stack
        //     direction="row"
        //     sx={{
        //       background: "#0d57a1",
        //       color: "info.main",
        //       px: 2,
        //       py: 1.2,
        //       fontSize: "20px",
        //       justifyContent: "space-between",
        //       alignItems: "center",
        //     }}>
        //     <Typography variant="inherit">Texting Opt-In</Typography>

        //     <Stack direction="row" alignItems="center" spacing="sm">
        //       {(isAuthorized(ROOT_PERMISSION, PermissionAction.Create) && listItems.filter(x => x.id == 0).length == 1) && (
        //         <Button
        //           variant="text"
        //           onClick={() =>
        //             navigate({
        //               pathname: studentTextingOptinPageRoute.getPath({
        //                 id: 0,
        //                 studentId: params.studentId,
        //                 crudMode: "edit",
        //                 screenType: "dialog",
        //               }),
        //             })
        //           }
        //           sx={{ minWidth: "auto", color: "info.main" }}
        //         >
        //           + New
        //         </Button>
        //       )}
        //     </Stack>
        //   </Stack>
        // }
        tableContainer={
          <TableContainer ref={tableContainerRef}>
            <Table stickyHeader>
              <TableBody>
                {listItems.filter(x => x.id != 0).map((listItem) => (
                  <TableRow
                    key={listItem.id}
                    onClick={() =>
                      navigate({
                        pathname: studentTextingOptinPageRoute.getPath({
                          id: listItem.id,
                          studentId: params.studentId,
                          crudMode: "view",
                          screenType: "dialog",
                        }),
                      })
                    }
                  >
                    <TableCell>{listItem.optInMethod?.name}</TableCell>
                    <TableCell>{formatDate(listItem.optInDate)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        }
      />

      <ListContext.Provider value={{ loadList: (options) => loadList(listFilter, { resetPage: options?.resetPage }) }}>
        {matchTemplatePath(studentTextingOptinPageRoute.templatePath) && <Outlet />}
      </ListContext.Provider>
    </>
  );

  return (
    <Dialog
      isForm
      open={true}
      onClose={() => handleClose(navigate)}
      maxWidth="md"
      header={pageHeader}
      content={pageBody}
    />
  );
};
